import { Button } from "@/components/ui/Button";
import { formatEstimateRange, type EstimateRange } from "./estimate-api";
import styles from "./EstimateReviewGate.module.css";

/**
 * Pre-submit estimate review — the deliberate budget decision point. The
 * range is the hero; the customer chooses to spend their contact details
 * ("Get my exact quote") or self-select out / adjust. `range` is null
 * while it is worked out, and the screen says so in one line that stays
 * true for the whole wait; with no range at the end the wizard skips
 * straight to Contact (never blocked on the estimate service).
 */
export function EstimateReviewGate({
  range,
  companyName,
  onContinue,
  onAdjust,
}: {
  range: EstimateRange | null;
  companyName?: string;
  onContinue: () => void;
  onAdjust: () => void;
}): React.JSX.Element {
  if (!range) {
    return (
      <div className={styles.gate}>
        <div className={styles.decision} role="status">
          <p className={styles.label}>Working out your estimate…</p>
          <button type="button" onClick={onAdjust} className={styles.adjust}>
            Tweak my answers
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.gate}>
      <div className={styles.decision}>
        <p className={styles.label}>Here&apos;s your estimated range</p>
        <p className={styles.range}>{formatEstimateRange(range)}</p>
        <p className={styles.note}>
          excl. GST · {companyName ?? "the company"} will confirm your final
          quote
        </p>

        <div className={styles.actions}>
          <Button onClick={onContinue}>Get my exact quote</Button>
          <button type="button" onClick={onAdjust} className={styles.adjust}>
            Tweak my answers
          </button>
        </div>
      </div>
    </div>
  );
}
